<template>
	<div id="retrospect" style="margin-top: 67px;">
		<div class="focuImg" ref="element">
			<div id="bannerimg" class="swiper-container bjh bannerimg">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<img style="width: 100%;" src="/static/img/img_banner1.png" alt="农产品追溯" />
					</div>
					<div class="swiper-slide">
						<img style="width: 100%;" src="/static/img/img_banner2.png" alt="农产品追溯" />
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<div v-if="navBarFixed == true" style="height: 68px;"></div>
		<ul class="TopNav" :class="navBarFixed == true ? 'navBarWrap' :''">
			<li :class="TopNav==1?'active':''" @click="goAnchor('#a')">
				解决方案
			</li>
			<li :class="TopNav==2?'active':''" @click="goAnchor('#b')">
				公司实力
			</li>
			<li :class="TopNav==3?'active':''" @click="goAnchor('#c')">
				本地化服务
			</li>
			<li :class="TopNav==4?'active':''" @click="goAnchor('#d')">
				客户案例
			</li>
			<li :class="TopNav==5?'active':''" @click="goAnchor('#e')">
				联系我们
			</li>
		</ul>
		<a class="content2 flexY content1 bjh zuhe" ref="a">
			<div class="mddw" id="a"></div>
			<div class="">
				<p class="biaoti">解决方案</p>
				<ul class="faUl">
					<li class="faList">
						<div style="width: 320px;">
							<p class="name">环境监测</p>
							<p class="text">利用视频直播/录播技术，让用户对其购买或认证的产品的生命周期进行监控。</p>
							<div class="imgList">
								<div><img src="../../static/img/icon_index.png" alt="农产品追溯" />
									<p>各项指标</p>
								</div>
								<div><img src="../../static/img/icon_feed.png" alt="农产品追溯" />
									<p>环保饲料</p>
								</div>
								<div><img src="../../static/img/icon_sourceofwater.png" alt="农产品追溯" />
									<p>环保水源</p>
								</div>
							</div>
						</div>
						<div style="margin-left: 242px;">
							<img src="../../static/img/img_hjjc.png" alt="农产品追溯" />
						</div>
					</li>
					<li class="faList">
						<div style="padding-left: 143;">
							<img src="../../static/img/img_syzb.png" alt="农产品追溯" />
						</div>
						<div style="margin-left: 85px;" class="textBox">
							<p class="name">溯源直播</p>
							<p class="text">专业直播镜头，可视农业，溯源直播</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_cloudlive.png" alt="农产品追溯" />
									<p>功能齐全</p>
								</div>
								<div><img src="../../static/img/icon_fullfunction.png" alt="农产品追溯" />
									<p>云直播</p>
								</div>
							</div>
						</div>
					</li>
					<li class="faList">
						<div style="width: 339px;">
							<p class="name">安全检测</p>
							<p class="text">利用智能检测技术，针对农产品的农药残留等数据进行检测，确定其产品合格。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_security.png" alt="农产品追溯" />
									<p>安全</p>
								</div>
								<div><img src="../../static/img/icon_convenient.png" alt="农产品追溯" />
									<p>便捷</p>
								</div>
							</div>
						</div>
						<div style="margin-left: 100px;">
							<img src="../../static/img/img_testing.png" alt="农产品追溯" />
						</div>
					</li>
					<li class="faList" style="height: 570px;">
						<div style="padding-left: 143;">
							<img src="../../static/img/img_qklfw.png" alt="农产品追溯" />
						</div>
						<div style="margin-left: 85px;width: 320px;" class="textBox">
							<p class="name">区块链防伪</p>
							<p class="text">利用区块链防篡改的属性，实现一物一码全流程正品追溯。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_hardtocopy.png" alt="农产品追溯" />
									<p>难仿制</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_easytoidentify.png" alt="农产品追溯" />
									<p>易识别</p>
								</div>
								<div><img src="../../static/img/icon_customization.png" alt="农产品追溯" />
									<p>定制化</p>
								</div>
							</div>
						</div>
					</li>
					<li class="faList">
						<div style="width: 400px;">
							<p class="name">溯源平台服务</p>
							<p class="text">一站式食品、农产品、商品追溯、O2O营销云服务平台，实现对产品数据采集跟踪。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_wholeprocesstracing.png" alt="农产品追溯" />
									<p>全程追溯</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_statisticalanalysis.png" alt="农产品追溯" />
									<p>统计分析</p>
								</div>
								<div><img src="../../static/img/icon_customization.png" alt="农产品追溯" />
									<p>定制化</p>
								</div>
							</div>
						</div>
						<div style="margin-left:138px;">
							<img src="../../static/img/img_syptfw.png" alt="农产品追溯" />
						</div>
					</li>
					<li class="faList" style="padding-left: 105px;">
						<div>
							<img src="../../static/img/img_dsjfx.png" alt="农产品追溯" />
						</div>
						<div style="margin-left: 85px;width: 376px;" class="textBox">
							<p class="name">大数据分析</p>
							<p class="text">为政府监管部门或企业提供大数据分析平台，让政府或企业实时把握产品信息及数据，做出实时决策。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_intelligence.png" alt="农产品追溯" />
									<p>智能</p>
								</div>
								<div style="margin-right: 36px;"><img src="../../static/img/icon_dataanalysis.png" alt="农产品追溯" />
									<p>数据分析</p>
								</div>
								<div><img src="../../static/img/icon_visualization.png" alt="农产品追溯" />
									<p>可视化</p>
								</div>
							</div>
						</div>
					</li>
					<li class="faList" style="padding-left: 274px;">
						<div>
							<p class="name">线上电商</p>
							<p class="text">从工厂直接到用户。</p>
							<div class="imgList" style="justify-content: flex-start;">
								<div style="margin-right: 36px;"><img src="../../static/img/icon_fresh.png" alt="农产品追溯" />
									<p>新鲜</p>
								</div>
								<div><img src="../../static/img/icon_substantialbenefits.png" alt="农产品追溯" />
									<p>实惠</p>
								</div>
							</div>
						</div>
						<div style="margin-left:154px;">
							<img src="../../static/img/img_xsds.png" alt="农产品追溯" />
						</div>
					</li>
				</ul>
			</div>
		</a>
		<a class="content2 flexY  content1 anli" style="display: flex;justify-content: center;align-items: center;height: 352px;box-sizing: border-box;" ref="b">
			<div class="mddw" id="b"></div>
			<!-- 数据展示墙 -->
			<div id="home_dataShow">
				<div class="dataShow_box">
					<div class="dataShow_list" v-for="item in dataShow">
						<div class="dataShow_count">{{item.start}}<span>+</span></div>
						<div class="dataShow_text">{{item.text}}</div>
					</div>
				</div>
			</div>
		</a>
		<a class="content1 flexY bjh" ref="c" style="height: 912px;box-sizing: border-box;">
			<div class="mddw" id="c"></div>
			<div class="x">
				<p class="biaoti" style="margin-bottom: 0;">遍布全国的销售网络提供本地化的服务</p>
				<p class="fbiaoti">无论你身在何处，均能获得安宣本地化的服务体验</p>
				<div class="JJFA">
					<div class="l">
						<div class="topxian" style="margin-top:150px;"></div>
						<p class="pTop">500+</p>
						<p class="">服务商</p>
						<div class="topxian"></div>
						<p class="pTop">7×24h</p>
						<p class="">优质服务</p>
					</div>
					<div>
						<img style="width: 643px;height: 595px;" src="/static/img/retrospect_local.png" alt="农产品追溯" />
					</div>
				</div>
			</div>
		</a>
		<a class="content2 flexY content1 anli" style="height: 1100px;box-sizing: border-box;" ref="d">
			<div class="mddw" id="d"></div>
			<div class="x">
				<p class="biaoti">客户案例</p>
				<ul class="iocBox">
					<li v-for="(item,index) in anli" :key="'anli'+index">
						<img :src="item.src" alt="农产品追溯" />
						<div class="bottomBox">
							<p v-text="item.name"></p>
						</div>
					</li>
				</ul>
			</div>
		</a>
		<a class="content2 flexY content1 anli" style="height: 802px;display: flex;align-items: center;box-shadow: 1px 15px 20px rgba(0,0,0,0.3);box-sizing: border-box;position: relative;">
			<div class="mddw"></div>
			<img style="margin-right: 360px;" src="../../static/img/img_rrdsncpsydsyz.png" alt="农产品追溯" />
			<div class="sytext">
				<div class="gang"></div>
				<p class="p1">人人都是农产品溯源的受益者</p>
				<p class="p2">浙江安宣致力于用最先进的理念与技术去支撑中国食品安全的未来，助力中国经济的发展。</p>
			</div>
		</a>
		<div style="height: 196px;line-height: 196px;font-size: 24px;font-weight: 400;color: #FEFEFE;background:url('../../static/img/img_bg_contactus.png') 0/100% 100%;text-align: center;">
			现在联系我们，即可为您定制农产品溯源方案！
		</div>
		<div class="footerbox" ref="e">
			<div class="mddw" id="e"></div>
			<div class="footerboxTop">
				<div class="list1">
					<p class="p1">联系我们</p>
					<div class="xian"></div>
					<p class="p2">服务热线</p>
					<p class="p3">0571-87357305</p>
					<p class="p2">公司邮箱</p>
					<p class="p3">zjax@ansuw.com</p>
				</div>
				<div class="list2">
					<p class="p1">产品服务</p>
					<div class="xian"></div>
					<p class="p1" style="line-height: 45px;margin: 0;">软件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a href="http://www.ax168.com/system?activeIndex=0">食品追溯系统</a>
						<a href="http://www.ax168.com/system?activeIndex=1">食品检测系统</a>
						<a href="http://www.ax168.com/system?activeIndex=2">市场运营系统</a>
						<a href="http://www.ax168.com/system?activeIndex=3">商家管理系统</a>
						<a href="http://www.ax168.com/system?activeIndex=4">会员营销系统</a>
						<a href="http://www.ax168.com/system?activeIndex=5">网上菜场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=6">市场招商系统</a>
						<a href="http://www.ax168.com/system?activeIndex=7">电子结算系统</a>
						<a href="http://www.ax168.com/system?activeIndex=8">智能巡查系统</a>
						<a href="http://www.ax168.com/system?activeIndex=9">数据展示系统</a>
						<a href="http://www.ax168.com/system?activeIndex=10">智慧农场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=11">智慧禽畜系统</a>
						<a href="http://www.ax168.com/system?activeIndex=12">智慧水产系统</a>
					</div>
					<p class="p1" style="line-height: 45px;margin: 0;">硬件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a>智慧农贸追溯电子秤</a>
						<a>商户信用公示屏</a>
						<a>放心农贸触摸一体机</a>
						<a>数据大屏</a>
					</div>
				</div>
				<div class="list3">
					<p class="p1">关于我们</p>
					<div class="xian"></div>
					<p class="p2">
						<a href="http://www.ax168.com/about/#a">企业简介</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#b">企业优势</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#c">资质荣誉</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#d">企业特色</a>
					</p>
				</div>
			</div>
			<div class="footerboxC">
				<div class="xian"></div>
				<div class="textList">
					<p>解决方案</p>
					<p>
						<a href="http://www.ax168.com/publicity">智慧农贸解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/ygst">阳光厨房解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/zycpzs">重要产品追溯解决方案</a>
					</p>
				</div>
				<div class="xian"></div>
			</div>
			<div class="footerboxb">
				<p>地址： 浙江省杭州市西湖区西园八路11号一期D座506-507</p>
        <p style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>
				<p>公安部备案号：33010602001517</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		data() {
			return {
				navBarFixed: false,
				gengduo: false,
				TopNav: 1,
				anli: [{
					name: '山东省富硒甜瓜',
					src: '/static/img/img_Shandongmelon_1.png'
				}, {
					name: '山东省沙瓤西红柿',
					src: '/static/img/img_Shandongtomato_2.png'
				}, {
					name: '山东省彩虹西瓜',
					src: '/static/img/img_Shandongwatermelon_3.png'
				}, {
					name: '河南省滑县道口义祥张烧鸡',
					src: '/static/img/img_Henanroastchicken_4.png'
				}, {
					name: '陕西榆林沙地红薯',
					src: '/static/img/img_Yulinsweetpotato.png'
				}, {
					name: '海南省桥头地瓜',
					src: '/static/img/img_Hainansweetpotato_6.png'
				}],
				dataShow: [{
						text: '多年技术沉淀  通过双软认证',
						count: 10,
						start: 0,
						timer: ''
					},
					// {text: '数十项软件著作权 国家高新技术企业',count: 20,start: 0,timer: ''},
					{
						text: '多项软件著作权  国家高新技术企业',
						count: 20,
						start: 0,
						timer: ''
					},
					{
						text: '超强技术团队  获评大数据企业',
						count: 100,
						start: 0,
						timer: ''
					}, {
						text: '追溯系统覆盖一万多家大中型商超、批发配送企业',
						count: 10000,
						start: 9800,
						timer: ''
					}
				],
				fuwu: [{
					name: '业务支持',
					src: '/static/img/img_business_1.png',
					text: '专属合作伙伴拓展经理提供业务支持和商务支持，帮助您在“产品质量安全信息化体系”领域取得成功。'
				}, {
					name: '培训支持',
					src: '/static/img/img_train_2.png',
					text: '为了用户更好的了解使用产品，安宣信息提供包括现场指导培训等多种服务。'
				}, {
					name: '专业技术支持',
					src: '/static/img/img_technology_3.png',
					text: '专项技术领域获得浙江安宣专业团队的技术支持，在垂直市场获得领先优势。'
				}],
         ICP_text:'浙ICP备15019864号-1',
      ICP:{
        "http://localhost:8081":"测试",
        "http://www.ax168.com":"浙ICP备15019864号-4",
        "http://www.anxuan360.com":"浙ICP备15019864号-1",
        "http://www.axnm168.com":"浙ICP备15019864号-5",
        "http://www.aswnm.com":"浙ICP备15019864号-7",
        "http://www.axny168.com":"浙ICP备15019864号-6"
      },
			}
		},
		created: function() {
        let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
			this.$emit('footer', false);
			this.$emit('footer1', false);
			this.$emit('footer2', true);

		},
		activated() {
			document.title = "安宣智慧农贸-智慧农贸方案-安宣农贸解决方案"
			document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
		},
		methods: {
      handNavGx(){
        window.open("https://beian.miit.gov.cn", '_blank')
      },
			getData() {
				var t = this;
				this.dataShow[0].timer = setInterval(function() {
					if(t.dataShow[0].start < t.dataShow[0].count) {
						t.dataShow[0].start = t.dataShow[0].start + 1;
					} else {
						clearInterval(t.dataShow[0].timer);
					}
				}, 150)
				this.dataShow[1].timer = setInterval(function() {
					if(t.dataShow[1].start < t.dataShow[1].count) {
						t.dataShow[1].start = t.dataShow[1].start + 1;
					} else {
						clearInterval(t.dataShow[1].timer);
					}
				}, 5)
				this.dataShow[2].timer = setInterval(function() {
					if(t.dataShow[2].start < t.dataShow[2].count) {
						t.dataShow[2].start = t.dataShow[2].start + 1;
					} else {
						clearInterval(t.dataShow[2].timer);
					}
				}, 15)
				this.dataShow[3].timer = setInterval(function() {
					if(t.dataShow[3].start < t.dataShow[3].count) {
						t.dataShow[3].start = t.dataShow[3].start + 1;
					} else {
						clearInterval(t.dataShow[3].timer);
					}
				}, 4)
			},
			goAnchor(selector) {
				this.$el.querySelector(selector).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},
			watchScroll() {
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				let a = this.$refs.a.offsetTop
				let b = this.$refs.b.offsetTop
				let c = this.$refs.c.offsetTop
				let d = this.$refs.d.offsetTop
				let e = this.$refs.e.offsetTop
				//				let f = this.$refs.f.offsetTop
				let height = this.$refs.element.offsetHeight
				//  当滚动超过 90 时，实现吸顶效果
				if(scrollTop + 70 >= a) {
					this.TopNav = 1
				}
				if(scrollTop + 70 >= b) {
					this.TopNav = 2
					this.getData();
				}
				if(scrollTop + 70 >= c) {
					this.TopNav = 3
				}
				if(scrollTop + 70 >= d) {
					this.TopNav = 4
				}
				if(scrollTop + 250 >= e) {
					this.TopNav = 5
				}
				//				if(scrollTop + 80 >= f) {
				//					this.TopNav = 6
				//				}
				if(scrollTop > height) {
					this.navBarFixed = true;
				} else {
					this.navBarFixed = false;
				}

			}
		},

		mounted() {
			//banner轮播
			var swiper = new Swiper('.bannerimg', {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				centeredSlides: true,
				autoplay: 3000,
				autoplayDisableOnInteraction: false,
				speed: 800,
				loop: true,
				// initialSlide: 3,
			})
			// 鼠标悬停控制轮播
			var comtainer = document.getElementById('bannerimg');
			comtainer.onmouseenter = function() {
				swiper.stopAutoplay();
			};
			// 鼠标离开 继续轮播
			comtainer.onmouseleave = function() {
				swiper.startAutoplay();
			}
			//		var swiper = new Swiper('.swiper-container', {
			//				slidesPerView: 'auto',
			//				pagination: '.swiper-pagination',
			//			});
			window.addEventListener("scroll", this.watchScroll);
			var th = this
			window.onresize = function() { //监听屏幕的改变
				document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
			};
		},
		components: {

		}
	}
</script>
<style>
	@import url('../css/retrospect.css');
	@import url('../css/home.css');
	[v-cloak] {
		display: none !important;
	}

	#home_dataShow {
		box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
	}

	.navBarWrap {
		position: fixed;
		top: 0px;
		z-index: 99999999999999999;
		background-color: #fff;
		width: 100%;
	}

	.focuImg {
		position: relative;
		overflow: hidden;
	}

	.focuImg .li {
		background-color: #668fe7;
		position: absolute;
		border-radius: .3rem;
		color: #fff;
		font-size: .08rem;
		font-weight: 500;
		padding: .06rem .2rem .06rem .2rem;
		transition: all 2s;
		opacity: 0;
	}

	.focuImg .li1.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li2.active {
		transform: translateY(0px);
		opacity: 1;
	}

	.focuImg .li3.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li1 {
		transform: translateX(-100px);
		width: .5rem;
		left: .75rem;
		bottom: .8rem;
	}

	.focuImg .li2 {
		transform: translateY(-100px);
		width: .75rem;
		right: 2.3rem;
		bottom: 1.38rem;
	}

	.focuImg .li3 {
		transform: translateX(100px);
		width: .65rem;
		right: 0.1rem;
		bottom: 1rem;
		z-index: 999999999999999999;
	}

	.swiper-container-horizontal>.swiper-pagination-bullets,
	.swiper-pagination-custom,
	.swiper-pagination-fraction {
		bottom: -40px;
	}

	.swiper-pagination-bullet {
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	.swiper-pagination-bullet-active {
		background: #fff;
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}
</style>
<style scoped>
	#home_dataShow .dataShow_box {
		width: 1500px;
	}

	.anli .iocBox li .bottomBox {
		position: absolute;
		bottom: 0;
		background-color: transparent !important;
		z-index: 0;
		height: 70px;
		line-height: 70px;
		padding-left: 19px;
	}

	.anli .iocBox li {
		margin-bottom: 39px !important;
	}

	.company_infoContect .guanzhu {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-bottom: 12px;
	}

	.company_infoContect .wxHao {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-top: 10px;
	}

	.pc {
		padding-top: 67px;
	}

	html,
	body {
		position: relative;
		height: 100%;
	}

	body {
		background: #eee;
		font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
		font-size: 14px;
		color: #000;
		margin: 0;
		padding: 0;
	}

	.swiper-container {
		width: 100%;
		height: 100%;
		background-color: rgba(248, 248, 248, 1);
	}

	.swiper-wrapper,
	.swiper-slide {
		background-color: rgba(248, 248, 248, 1);
	}

	.swiperBox {
		width: 33%;
		text-align: center;
		margin-bottom: .4rem;
		padding-left: .7rem;
		box-sizing: border-box;
		font-size: .2rem;
	}

	.swiperBox>img {
		margin: 0 auto;
		margin-bottom: .2rem;
		width: .7rem;
	}

	.swiperBox>div {
		white-space: nowrap;
	}

	.swiper-slide {
		text-align: center;
		font-size: 18px;
		flex-wrap: wrap;
		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}
	/*.swiper-slide:nth-child(2n) {
		width: 60%;
	}

	.swiper-slide:nth-child(3n) {
		width: 40%;
	}
	*/

  .TopNav li.active {
  	border-bottom: 1px solid #00C59F;
  	font-size: 18px;
  	font-family: Microsoft YaHei;
  	font-weight: bold;
  	color: rgba(20, 20, 20, 1);

  }

  .TopNav {

  	display: flex;
    width: 100%;
    /* width: 1200px; */
    box-sizing: border-box;
    justify-content: center;
  	box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
    margin-bottom: 10px;
  	/* padding-left: 450px; */
   /* float: right; */
  }

  .TopNav li {
   /* flex: 1;
      flex-grow: 1; */
    flex-shrink: 0;
  	cursor: pointer;
  	/* width: 120px; */
    padding:0 14px;
  	text-align: center;
  	margin: 0 30px;
  	height: 68px;
  	line-height: 68px;
  	display: inline-block;
  	font-size: 18px;
  	font-family: Microsoft YaHei;
  	font-weight: 400;
  	color: rgba(51, 51, 51, 1);
  }

	.indexImg {
		width: 1.53rem;
		margin-top: .7rem;
		margin-bottom: .44rem;
		display: block;
	}

	.indexImg>img {
		width: 100%;
	}

	.yd .bottom {
		height: .94rem;
		line-height: .94rem;
		text-align: center;
		font-size: .22rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(111, 116, 126, 1);
	}

	.fz42 {
		font-size: .42rem!important;
	}

	.lftext {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: .04rem;
	}

	.dianhua {
		width: .3rem;
		font-size: .06rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		margin: 0 auto;
		margin-top: .05rem;
	}

	.shijian {
		width: .45rem;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		color: #fff;
		text-align: center;
	}

	.heng {
		width: .27rem;
		height: 1px;
		background-color: #fff;
		margin: .06rem auto;
	}

	.lftext>img {
		margin-right: .03rem;
	}

	.lftext>p {
		font-size: .04rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
	}

	.lf .yuan>img {
		margin: 0 auto;
		display: block;
		width: 74%;
	}

	.lf {
		width: .45rem;
		height: 1.16rem;
		background: linear-gradient(0deg, rgba(0, 184, 148, 1), rgba(0, 197, 159, 1));
		border-radius: .23rem .23rem 0px 0px;
		position: fixed;
		right: 0;
		top: 40%;
		padding: .06rem 0;
		box-sizing: border-box;
	}

	.lianxi {
		height: .92rem;
		display: flex;
		align-items: center;
		background: url('/static/img/img_contactus_bg.png') no-repeat;
		background-size: cover;
		justify-content: center;
	}

	.yd .lianxi {
		height: 3.26rem;
	}

	.lianxi p {
		font-size: .11rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(254, 254, 254, 1);
		text-align: center;
	}

	.yd .lianxi p {
		font-size: .32rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(254, 254, 254, 1);
		text-align: center;
	}

	.yd .lianxi a {
		width: 3.06rem;
		height: .76rem;
		font-size: .28rem;
		line-height: .76rem;
		margin-top: .54rem;
	}

	.lianxi a {
		display: flex;
		width: .69rem;
		height: .18rem;
		line-height: .18rem;
		background: rgba(255, 255, 255, 1);
		border-radius: 1px;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(73, 141, 255, 1);
		margin: 0 auto;
		display: flex;
		justify-content: center;
		margin-top: .12rem;
	}

	.gengduo {
		display: block;
		cursor: pointer;
		width: .56rem;
		height: .18rem;
		border: 1px solid rgba(0, 197, 159, 1);
		text-align: center;
		line-height: .18rem;
		font-size: .05rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(0, 197, 159, 1);
		margin: .2rem auto;
		margin-top: .1rem;
	}

	.yd .gengduo {
		display: block;
		width: 3.16rem;
		height: .76rem;
		font-size: .3rem;
		line-height: .76rem;
		margin-top: .56rem;
		margin-bottom: .42rem;
	}

	.gengduo:hover {
		color: #fff;
		background-color: rgba(0, 197, 159, 1);
	}

	.x {
		width: 1200px;
	}

	.mb45 {
		margin-bottom: .45rem;
	}

	.yd .x {
		width: 100%;
	}

	.content1 {
		padding: .3rem;
		position: relative;
	}

	.content1 .mddw {
		position: absolute;
		top: -68px;
		width: 100%;
		height: 68px;
    left:0px;
		z-index: -1;
	}

	.yd .content1 {
		padding: .9rem .45rem;
	}

	.yd .content1.zuhe,
	.yd .content1.mokuai,
	.yd .content1.fangan {
		padding-bottom: .5rem;
	}

	.yd .content1.fuwu,
	.yd .content1.zuhe,
	.yd .content1.fangan {
		background-color: #fff;
	}

	.mokuai .gengduo {
		margin-bottom: 0;
		background-color: rgba(0, 197, 159, 1);
		color: #fff;
	}

	.mokuai .gengduo img {
		display: inline-block;
		margin-left: .03rem;
	}

	.bjh {
		background: rgba(248, 248, 248, 1);
	}

	.yd .xian {
		width: 1px;
		height: .45rem;
		background: rgba(99, 104, 108, 1);
		margin: 0 .1rem;
	}

	.flexY {
		display: flex;
		align-items: center;
	}

	.logoTop .logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo>img {
		width: .45rem;
	}

	.yd .logo>img {
		width: 2.2rem;
	}

	.logoTop {
		background-color: #fff;
		height: .3rem;
		padding-left: .11rem;
	}

	.yd .logoTop {
		background-color: #fff;
		height: 1.5rem;
		padding-left: .14rem;
	}

	.logoR p {
		font-family: inpin heiti;
		font-size: .05rem;
	}

	.yd .logoR p {
		font-family: inpin heiti;
		font-size: .2rem;
		color: #141414;
	}

	.content1 {
		justify-content: center;
	}

	.imgTextBox {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.yd .imgTextBox {
		display: block;
		width: 100%;
	}

	.imgTextBox p {
		font-size: .08rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		line-height: .16rem;
	}

	.pc .zuhe li {
		width: 1200px;
		height: 400px;
		background: rgba(255, 255, 255, 1);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 30px;
	}

	.pc .zuhe li .zuheBox {
		display: flex;
		align-items: center;
	}

	.fbiaoti {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-top: 23px;
		text-align: center;
		margin-bottom: 100px;
	}

	.JJFA {
		width: 1050px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}

	.topxian {
		width: 74px;
		height: 1px;
		background: #C8C7D8;
		margin-bottom: 15px;
		margin-top: 50px;
	}

	.JJFA .l .pTop {
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(48, 143, 255, 1);
		margin-bottom: 15px;
	}

	.JJFA .l {
		width: 340px;
	}

	.JJFA .l .Plist {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		position: relative;
		padding-left: 20px;
		line-height: 35px;
		margin-bottom: 49px;
	}

	.JJFA .l .Plist:before {
		content: "";
		position: absolute;
		left: 0;
		top: 10px;
		width: 8px;
		height: 16px;
		background: rgba(48, 143, 255, 1);
		border-radius: 4px;
	}

	.pc .zuhe li .zuheBox .rtext {
		margin-left: 144px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav {
		margin-top: 46px;
		display: flex;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav>div {
		width: 80px;
		margin-right: 36px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav>div:last-child {
		margin-right: 0;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav img {
		width: 80px;
		height: 80px;
	}

	.pc .zuhe li .zuheBox .rtext .tdNav p {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		text-align: center;
		margin-top: 24px;
	}

	.pc .zuhe li .zuheBox .rtext p:nth-child(1) {
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(44, 58, 70, 1);
	}

	.pc .zuhe li .zuheBox .rtext p:nth-child(2) {
		margin-top: 18px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(44, 58, 70, 1);
	}

	.pc .zuhe li .zuheBox>div>img {
		width: 224px;
		height: 298px;
	}

	.pc .zuhe li .rioc {
		box-sizing: border-box;
		position: absolute;
		right: 20px;
		top: 20px;
		width: 122px;
		height: 42px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 5px 14px 4px rgba(91, 140, 223, 0.09);
		border-radius: 21px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-left: 20px;
		padding-right: 5px;
	}

	.pc .zuhe li .rioc span {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		line-height: 42px;
	}

	.pc .zuhe li:nth-child(1) .rioc span {
		color: #5AA6FF;
	}

	.pc .zuhe li:nth-child(2) .rioc span {
		color: #5BCA54;
	}

	.pc .zuhe li:nth-child(3) .rioc span {
		color: #948FFF;
	}

	.pc .zuhe li .rioc img {
		width: 36px;
		height: 36px;
		margin: 0;
	}

	.yd .imgTextBox p {
		font-size: .3rem;
		line-height: .54rem;
		color: #323233;
	}

	.yd .fangan .imgTextBox p {
		margin-bottom: .41rem;
	}

	.imgTextBox>div:first-child {
		margin-right: .39rem;
		width: 3.3rem;
	}

	.yd .imgTextBox>div:first-child {
		width: 100%;
		margin: 0;
		margin-bottom: .74rem;
	}

	.imgTextBox>div:first-child>img {
		width: 100%;
	}

	.iocBox {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.mokuai .iocBox li {
		width: 16.66%;
		margin-bottom: .2rem;
	}

	.iocBox li {
		position: relative;
	}

	.yd .iocBox li {
		width: 33%;
		text-align: center;
		margin-bottom: .51rem;
	}

	.yd .mokuai .iocBox li>img {
		width: .8rem;
		height: .64rem;
	}

	.yd .fuwu .iocBox li>img {
		width: 2rem;
	}

	.yd .fuwu .iocBox li {
		width: 100%;
		margin-bottom: .79rem;
	}

	.yd .anli .iocBox li {
		width: 100%;
	}

	.yd .anli .iocBox li>img {
		width: 100%;
	}

	.yd .zuhe .iocBox li {
		width: 48%;
	}

	.yd .zuhe .iocBox li>img {
		width: 100%;
	}

	.yd .iocBox li>img {
		display: block;
		margin: 0 auto;
	}

	.iocBox li img {
		display: block;
		margin: 0 auto;
	}

	.iocBox li p {
		text-align: center;
		font-size: .07rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(60, 68, 79, 1);
		line-height: .09rem;
		margin-top: .12rem;
	}

	.yd .iocBox li p {
		font-size: .22rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(60, 68, 79, 1);
		line-height: .22rem;
	}

	.yd .mokuai .iocBox li p {
		margin-top: .2rem;
	}

	.yd .anli .iocBox li .bottomBox {
		width: 100%;
		height: 1.3rem;
		border: 0px solid #fff;
		background-color: #fff;
		display: flex;
		align-items: center;
		padding-left: .38rem;
		box-sizing: border-box;
	}

	.anli .iocBox li .bottomBox {
		width: 100%;
		height: .3rem;
		background-color: #fff;
		display: flex;
		align-items: center;
		box-sizing: border-box;
	}

	.anli .iocBox li .bottomBox p {
		margin-top: 0;
		height: .15rem;
		background-size: 100% 100%;
		font-size: .06rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: .15rem;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(20, 20, 20, 1);
	}

	.yd .anli .iocBox li .bottomBox p {
		margin-top: 0;
		height: .5rem;
		background: url('/static/img/img_case_name_bg_8.png') center no-repeat;
		background-size: 100% 100%;
		font-size: .28rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(255, 255, 255, 1);
		line-height: .5rem;
		padding: 0 .2rem;
		color: #fff;
	}

	.fuwu li {
		width: 230px;
		text-align: center;
	}

	.fuwu li p {
		margin-top: 0;
	}

	.fuwu li .p1 {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		margin-top: 21px;
		margin-bottom: 33px;
	}

	.yd .fuwu li .p1 {
		font-size: .32rem;
		color: rgba(51, 51, 51, 1);
		line-height: .32rem;
		margin-top: .2rem;
		margin-bottom: .24rem;
	}

	.fuwu li .p2 {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		line-height: 25px;
	}

	.yd .fuwu li .p2 {
		width: 5.04rem;
		font-size: .26rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(162, 162, 162, 1);
		text-align: center;
		line-height: .38rem;
		margin: 0 auto;
		text-align: center;
	}

	.yd .zuhe .iocBox li p {
		margin-top: 0;
		width: 100%;
		height: .26rem;
		line-height: .26rem;
		text-align: center;
		font-size: .06rem;
		box-sizing: border-box;
		font-family: Microsoft YaHei;
		border: 1px solid rgba(243, 246, 249, 1);
	}

	.yd .zuhe .iocBox li p {
		margin-top: 0;
		width: 100%;
		height: 0.93rem;
		line-height: 0.93rem;
		text-align: center;
		font-size: .28rem;
		box-sizing: border-box;
		font-family: Microsoft YaHei;
		border: 1px solid rgba(243, 246, 249, 1);
		background-color: #fff;
	}

	.yd .anli .iocBox li {
		margin-bottom: .3rem;
	}

	.anli .iocBox li {
		margin-bottom: .08rem;
	}

	.biaoti {
		font-size: .14rem;
		font-size: 36px!important;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
	}

	.yd footer {
		padding: .8rem .49rem;
		border: 2px solid rgba(28, 41, 70, 1);
	}

	.footerP {
		font-size: .24rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(164, 168, 176, 1);
	}

	.footerP .span1 {
		color: #fff;
	}

	.footerP .span2 {
		color: #00C59F;
	}

	.mb24 {
		margin-bottom: .24rem
	}

	.yd .biaoti {
		font-size: .44rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(50, 50, 51, 1);
		margin-bottom: .29rem;
		text-align: center;
		margin-bottom: .92rem;
	}

	.company_info {
		width: 4.3rem;
		margin: 0 auto;
		min-width: 1200px;
		height: 295px;
		color: #6f747e;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.company_info .company_infoDetail .company_infoDetail_logo {
		width: 153px;
		height: 50px;
		margin-bottom: 20px;
	}

	.company_info .company_infoDetail .company_infoDetail_text {
		margin-bottom: 12px;
	}

	.company_info .company_infoContect {
		display: flex;
	}

	.company_info .company_infoContect .company_infoContect_head {
		color: #ffffff;
		font-size: 18px;
		margin-bottom: 20px;
	}

	.company_info .company_infoContect .company_infoContect_title {
		margin-bottom: 12px;
	}

	.company_info .company_infoContect .company_infoContect_text {
		color: #ffffff;
		font-size: 20px;
		margin-bottom: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/retrospect.vue